import React, { useState, useEffect } from 'react';
import Home from '../sso/Home';
// import { Row,Col, InputGroup,Input,InputGroupAddon } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss';
import homeSearch from '../../assets/images/icon_home_search.png';
import CreateProject from '../createProject';
import UserProjects from '../userProjects';
import ProjectCards from '../userProjects/pcards';
import { chkAccAct, fetchCabpAct } from '../redux/profile/profileActions';
// import { showLoader } from '../redux/ctrl/ctrlActions';
import { fetchProjectsAct, fetchTagCancelAct, clearQuoteSearch } from '../redux/project/projActions';
import { Box } from '@mui/material';
import { MdOutlineManageSearch } from 'react-icons/md';
import TextField from '@mui/material/TextField';
import { fetchPrjAsn } from '../redux/prjasn/prjAsnActions';
import BuSelect from './BuSelect';
import { SignUp } from '@as-pmo-lrp-sso/sign-up';
import Loader from '../loader';
import { useTranslation } from 'react-i18next';
import COLORS from '../styles/COLORS';
import toastr from 'toastr';
import { useAuth0 } from '@auth0/auth0-react';
import { getEnvironment } from '../../utils';

const Project = () => {
  const { getIdTokenClaims } = useAuth0();
  const [idToken, setIdToken] = useState('');
  const profileState = useSelector((state) => state.profile);
  const projectState = useSelector((state) => state.project);
  const projectData = useSelector((state) => state.project.projects)
  const [searchText, setSearchText] = useState('');
  const [findProj, setFindProj] = useState(null);
  const [isOpenAdvanced, setIsOpenAdvanced] = useState(false);
  const [advanceSearchFields, setAdvanceSearchFields] = useState({});
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const handleChange = (e) => {
    e.preventDefault();
    setFindProj(e.target.value)
    setSearchText(e.target.value);
    dispatch(clearQuoteSearch());
    localStorage.removeItem('pgrid_filterModel');
    window.dispatchEvent(new Event('pgrid-clear-filters'));
  }

  const handleQuoteSearch = (result) => {
    const projectIds = result.length ? result.map(proj => proj.project_id) : [];
    const isValidProject = projectData.some(proj => projectIds.includes(proj.project_id));
    if (isValidProject) {
      setFindProj(projectIds)
    } else {
      // dispatch(clearQuoteSearch());
      clearSearch()
      toastr.error(t('You do not have permission to access this project'));
    }
  }

  useEffect(() => {
    async function fetchToken() {
      const token = await getIdTokenClaims();
      setIdToken(token.__raw);
    }
    fetchToken();
  }, []);

  useEffect(() => {
    // dispatch(chkAccAct(profileState.email))
    dispatch(fetchTagCancelAct())
  }, [])

  const clearSearch = () => {
    setFindProj(null);
    setAdvanceSearchFields({});
    dispatch(clearQuoteSearch());
  }

  const onClickRefresh = () => {
    let tempObjKey = [profileState.appAcc[0].business_unit, profileState.appAcc[0].bu_proj_count];
    let convertedObject = {
      [tempObjKey[0]]: tempObjKey[1]
    }
    let allBUObj = { ...profileState.appAcc[0].secondary_office_count, ...convertedObject };
    //  if (profileState.capb.findIndex((o)=>o.PWSALPRJ === 'Y') >= 0) {
    //   dispatch(fetchProjectsAct());
    dispatch(fetchProjectsAct({
      eid: profileState.email, prjCnt: profileState.appAcc[0].project_count, fromNo: projectState.projects.length + 1, toNo: projectState.projects.length + 2000,
      capabilities: profileState.capb, totalProjectCount: allBUObj[profileState.bu]
    }))
    //    }else {
    //    dispatch(fetchProjectsAct({ 
    //     eid: profileState.email, prjCnt: profileState.appAcc[0].project_count, fromNo: projectState.projects.length + 1, toNo: projectState.projects.length + 2000,
    //     capabilities: profileState.capb,totalProjectCount:profileState.appAcc[0]. total_proj_count
    //   }))
    //  }

  }
  const onBUChange = (val) => {
    let tempObjKey = [profileState.appAcc[0].business_unit, profileState.appAcc[0].bu_proj_count];
    let convertedObject = {
      [tempObjKey[0]]: tempObjKey[1]
    }
    let allBUObj = { ...profileState.appAcc[0].secondary_office_count, ...convertedObject };

    //  if (profileState.capb.findIndex((o)=>o.PWSALPRJ === 'Y') >= 0) {
    if (profileState.email && profileState.appAcc.length > 0 && (profileState?.capb?.length > 0)) {
      dispatch(fetchProjectsAct({
        eid: profileState.email, prjCnt: profileState.appAcc[0].project_count,
        capabilities: profileState.capb, totalProjectCount: allBUObj[val], needToReload: true
      }))
    }
    // }
  }

  if (profileState.appAcc[0]?.access_exist === 'Y') {
    return (
      <>
        <Loader />
        <Box className="project_header" sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: COLORS.blue,
          paddingX: 2,
          paddingY: 1
        }}>
          <BuSelect onBUChange={onBUChange} />
          <Box sx={{ display: "flex", justifyContent: "center", width: "33%" }} >
            <TextField value={searchText} className='form-control border-0 srchtxt' id='srchiptxt' name='srchiptxt' placeholder={t('Search Project')} style={{ borderBottomLeftRadius: "15px", borderTopLeftRadius: "15px", borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
              onChange={(e) => handleChange(e)}></TextField>
            <span className="input-group-text" style={{ marginTop: '1px', marginLeft: '-7px' }} >
              <img src={homeSearch} width="auto" height="20"></img>
            </span>
            <div className="tooltip-AS">
              <MdOutlineManageSearch
                onClick={() => setIsOpenAdvanced(true)}
                style={{
                  cursor: 'pointer',
                  marginLeft: '8px',
                  marginTop: '2px',
                  color: 'white',
                  width: '30px',
                  height: '31px',
                }}
              />
              <span className="tooltip-text">Advanced Search</span>
            </div>
          </Box>
          <Box sx={{ width: "33%", display: "flex", justifyContent: "flex-end" }}>
            {/* Advance search icon */}
            <CreateProject
              handleQuoteSearch={handleQuoteSearch}
              setAdvanceSearchFields={setAdvanceSearchFields}
              isOpenAdvanced={isOpenAdvanced}
              setIsOpenAdvanced={setIsOpenAdvanced}
              clearSearch={() => clearSearch()} />
          </Box>
        </Box>
        <UserProjects
          onClickRefresh={onClickRefresh}
          advanceSearchFields={advanceSearchFields}
          clearSearch={() => clearSearch()}
        />
        <ProjectCards data={profileState} findProj={findProj} advanceSearchFields={advanceSearchFields} />
      </>
    )
  }
  else if (profileState.appAcc[0]?.access_exist === 'N' && idToken) {
    return <SignUp email={profileState.email} app='PRJWSC' token={idToken} environment={getEnvironment()} />;
  }
  else {
    return null;
  }
}

export default Project;